import { Vehicle } from 'frontend/vehicles'
import { markRaw } from 'vue'

import { FILTERS_CONFIG } from './tracker-devices-table-filters-config'

export { FILTERS_CONFIG }

const COLUMNS_CONFIG = {
  remoteId: {
    label: 'Tracker ID',
    header: {
      sort: ['remoteIdInt', 'remoteId'],
    },
    cell: {
      kind: 'simple',
      path: 'remoteId',
    },
  },
  name: {
    label: 'Name',
    header: {
      sort: 'name',
    },
    cell: {
      kind: 'simple',
      path: 'name',
    },
  },
  vehicle: {
    label: 'Vehicle',
    header: {
      sort: ['vehicleFleetNumberPrefix', 'vehicleFleetNumberInt'],
    },
    cell: {
      kind: 'component',
      component: markRaw(Vehicle),
      componentProps: item => ({
        vehicle: item.vehicle,
        detailed: true,
      }),
    },
  },
  provider: {
    label: 'Provider',
    header: {
      sort: 'provider',
    },
    cell: {
      kind: 'simple',
      path: 'provider',
    },
  },
  vin: {
    label: 'VIN',
    header: {
      sort: 'vin',
    },
    cell: {
      kind: 'simple',
      path: 'metadata.vin',
    },
  },
  updatedAt: {
    label: 'Updated Datetime',
    header: {
      sort: 'updatedAt',
    },
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: item => ({ t: item.updatedAt }),
    },
  },
  updatedAtTime: {
    label: 'Updated Time',
    header: {
      sort: 'updatedAt',
    },
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: item => ({
        t: item.updatedAt,
        format: 'timeOnly',
      }),
    },
  },
  updatedAtDate: {
    label: 'Updated Date',
    header: {
      sort: 'updatedAt',
    },
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: item => ({
        t: item.updatedAt,
        format: 'dateOnly',
      }),
    },
  },
}

const DEFAULT_COLUMNS = ['remoteId', 'name', 'provider', 'vehicle', 'updatedAt']

const FIELDS = [
  'id',
  'color',
  'name',
  'provider',
  'tracking_status',
  'metadata',
  'created_at',
  'updated_at',
  'remote_id',
  'event_id',
  {
    vehicle: [
      'id',
      'fleet_number',
      'registration_plate',
      { vehicle_model: ['id', 'name', { vehicle_brand: ['id', 'name'] }] },
    ],
  },
]

const SUBSCRIPTIONS = {
  items: 'TrackerDevicesChannel',
  vehicles: 'VehiclesSimpleChannel',
}

export { COLUMNS_CONFIG, DEFAULT_COLUMNS, FIELDS, SUBSCRIPTIONS }
